import AMLDetailList from '../../../../components/AMLDetailsList';
import Button from '../../../../components/Button';
import StickyPanel from '../../../../components/StickyPanel';
import { t } from '../../../../lang';
import { createRootModal } from '../../RootModal';
import './AMLDetailsModal.scss';

const AMLDetailsModal = createRootModal(({ handleClose, outsideParams }) => {
	const { list = [] } = outsideParams;
	const amlDetailsListHeader = [t('Type'), t('Share V2'), t('Balance')];

	const listCounterpartiesAml = list.map(item => ({
		title: item.Name,
		amount: item.FiatAmount,
		percent: item.PercentageAmount,
	}));

	return (
		<div className='AMLDetailsModal'>
			<StickyPanel
				controls={
					<Button onClick={handleClose} styleType='primary'>
						{t('Got it')}
					</Button>
				}
			>
				<div className='AMLDetailsModal_content'>
					<div className='AMLDetailsModal_content_title'>{t('Counterparties')}</div>
					<AMLDetailList
						amlDetailsList={listCounterpartiesAml}
						amlDetailsListHeader={amlDetailsListHeader}
						showIcon={false}
					/>
				</div>
			</StickyPanel>
		</div>
	);
});

export default AMLDetailsModal;
